module.exports = __webpack_public_path__ + "img/tdb.bfd0484d.png";